import { translate } from '@lucidlink/uicore';
export const getCompletedStepsTexts = () => [
    {
        heading: translate("Let's get you started!"),
        description: translate('Complete the steps in the checklist and start your journey.'),
    },
    {
        heading: translate("You're off to a great start!"),
        description: translate('Just two more steps to go.'),
    },
    {
        heading: translate('Almost there!'),
        description: translate('Just one more step to activate your workspace.'),
    },
    {
        heading: translate("You're all set! 🚀"),
        description: translate('Your workspace is fully ready.'),
    },
];
